import { LayoutElementType } from '../types/layoutBuilder.types'

export const getKeyNameForDisabledFieldsOfSingleLookup = (
  lookupElementKeyName: string,
  associatedFieldKeyName: string
): string => {
  return `disabled_${lookupElementKeyName}_${associatedFieldKeyName}`
}

export const getKeyNameOfElement = (
  el: LayoutElementType
): string | undefined => {
  if (el.parent) {
    return getKeyNameForDisabledFieldsOfSingleLookup(
      el.parent.lookupKeyName,
      el.keyName ?? ''
    )
  }
  return el.keyName
}
